import { Injectable } from '@angular/core';
import { AuthConfig } from 'angular2-jwt';
import { HttpModule, XHRBackend, ConnectionBackend, Http, RequestOptions, RequestOptionsArgs, Request, Response, Headers } from '@angular/http';
import { JwtHttpModule, JwtConfigService, JwtHttp, RefreshConfig } from 'angular2-jwt-refresh';
import { Observable } from 'rxjs/Observable';
import { AppConfig } from '../../app.config';
import { Constants, GlobalsService, HelperService, NotifyService } from '../../shared/shared';

@Injectable()
export class ExtendedJwtHttp extends JwtHttp {
    constructor(cfgService: JwtConfigService, http: Http, private globalsService: GlobalsService, private helperService: HelperService, private notifyService: NotifyService, options?: RequestOptions) {
        super(cfgService, http, options);
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.request(url, options));
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.get(url, options));
    }

    post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.post(url, body, this.getRequestOptionArgs(options)));
    }

    put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.put(url, body, this.getRequestOptionArgs(options)));
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.delete(url, options));
    }

    getRequestOptionArgs(options?: RequestOptionsArgs): RequestOptionsArgs {
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }
        //options.headers.append('Content-Type', 'application/json');
        return options;
    }

    private intercept(observable: Observable<Response>): Observable<Response> {
        this.globalsService.beforeRequest.emit("beforeHttpRequestEvent");
        this.globalsService.IsBusy.next(true);

        return observable.do(
            () => {
                return this.globalsService.afterRequest.emit("afterHttpRequestEvent");
            },
            (error) => {
                //this.globalsService.IsBusy.next(false)

                if (this.globalsService.CatchHttpErrorsGlobal)
                    this.notifyService.TME("Fehler", this.helperService.ExtractErrorMessage(error));
            },
            () => {
                //this.globalsService.IsBusy.next(false)
            }
        ).finally(() => {
            this.globalsService.IsBusy.next(false)
        });
    }
}

export function jwtHttpServiceFactory(http: Http, options: RequestOptions, xhrBackend: XHRBackend,
    globalsService: GlobalsService, helperService: HelperService, notifyService: NotifyService): ExtendedJwtHttp {
    let jwtOptions: RefreshConfig;
    let authConfig: AuthConfig;

    jwtOptions = {
        endPoint: AppConfig.Urls.WebAPI + '/api/token/refreshToken',
        // optional
        // payload: { type: 'refresh' },
        beforeSeconds: 8640, // refresh token before 10 min
        tokenName: Constants.JWT_ACCESSTOKEN_NAME,
        refreshTokenGetter: (() => {
            let jwtToken = localStorage.getItem(Constants.JWT_REFRESHTOKEN_NAME);
            if (jwtToken) {
                return jwtToken;
            }
            return null;
        }),
        tokenSetter: ((res: Response): boolean | Promise<void> => {
            let jwtToken: any = res.json();
            if (!jwtToken[Constants.JWT_ACCESSTOKEN_NAME] || !jwtToken[Constants.JWT_REFRESHTOKEN_NAME]) {
                localStorage.removeItem(Constants.JWT_ACCESSTOKEN_NAME);
                localStorage.removeItem(Constants.JWT_REFRESHTOKEN_NAME);

                return false;
            }

            localStorage.setItem(Constants.JWT_ACCESSTOKEN_NAME, jwtToken[Constants.JWT_ACCESSTOKEN_NAME]);
            localStorage.setItem(Constants.JWT_REFRESHTOKEN_NAME, jwtToken[Constants.JWT_REFRESHTOKEN_NAME]);
            return true;
        })
    };

    authConfig = new AuthConfig({
        headerName: 'Authorization',
        headerPrefix: 'Bearer',
        tokenName: Constants.JWT_ACCESSTOKEN_NAME,
        tokenGetter: (() => {
            let tokenString: string = localStorage.getItem(Constants.JWT_ACCESSTOKEN_NAME);
            return tokenString;
        }),
        //globalHeaders: [{ 'Content-Type': 'application/json' }],
        noJwtError: true, // continue with an unauthenticated request on error instead
        noClientCheck: true
    });
    return new ExtendedJwtHttp(new JwtConfigService(jwtOptions, authConfig), http, globalsService, helperService, notifyService, options);
}

export const extendedJwtProvider: any[] = [
    {
        provide: ExtendedJwtHttp,
        deps: [Http, RequestOptions, XHRBackend, GlobalsService, HelperService, NotifyService],
        useFactory: jwtHttpServiceFactory
    }
];




// WEBPACK FOOTER //
// ./src/app/_authentication/http/jwthttp.ts